import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserContactCompanyOutput } from 'user/model/contact/user-contact-company.output';

@Injectable()
export abstract class UserContactCompanyApplicationPort {
	public abstract fetchUserContactCompanies(): Observable<
		UserContactCompanyOutput[] | Error
	>;
}
